import { Grid } from '@material-ui/core';
import { Field } from 'formik';
import React, { Fragment } from 'react';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';

import type { IForm } from 'v2/components/Shared/Content';

import type { SupportRefund as SupportRefundClass } from '../../classes/General';

interface IProps extends IForm<SupportRefundClass> {}

function SupportRefund(props: IProps) {
  const { setFocus } = props;
  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Field label='E-mail de suporte' name='support_email' id='support_email' onFocus={setFocus} component={TextFormField} />
        </Grid>
        <Grid item xs={12}>
          <Field label='Prazo para reembolso' name='refund_days' id='refund_days' type='number' onFocus={setFocus} component={TextFormField} />
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default SupportRefund;
